import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import styles from "./PrintButton.module.scss";

interface IPrintButtonProps {
    dataCy?: string;
    className?: string;
    rightMargin?: number;
    onClickCallback?: () => void | Promise<void>;
    isDisabled?: boolean;
}
class PrintButton extends BaseReactComponent<IPrintButtonProps> {
    public render(): JSX.Element {
        return (
            <button
                data-cy={this.props.dataCy}
                disabled={this.props.isDisabled}
                className={`button push-right-5 ${styles.printButton} ${this.props.className ?? ""}`}
                onClick={async (event: React.MouseEvent) => await this.handleClick(event)}
                style={{ marginRight: !IsNullOrUndefined(this.props.rightMargin) ? `${this.props.rightMargin}px` : null }}
            >
                <i
                    className="fi-print col-lg-icon"
                >&nbsp;
                </i>

            </button>
        );
    }

    public async handleClick(event: React.MouseEvent): Promise<void> {
        event.stopPropagation();

        await this.props.onClickCallback?.();
    }
}

export { PrintButton };
